import { Button, Column } from '@/semantic-ui/components';
import * as classnames from 'classnames';
import * as React from 'react';
import { Position } from 'sol-data';
import style from './position-pill.less';

interface IDistributionPillProps {
  position: Position;
  selected: boolean;
  handleClick: (id: number) => void;
}

export const PositionPill = ({ position, selected, handleClick }: IDistributionPillProps) => {
  return (
    <Column mobile={16} tablet={8} computer={4}>
      <Button
        fluid
        className={classnames(style.pill, {
          [style.selectedPill]: selected,
          [style.unSelectedPill]: !selected,
        })}
        onClick={() => handleClick(position.id)}
        type="button"
      >
        <p className={style.header}>
          {position.label} - {position.description}
        </p>
      </Button>
    </Column>
  );
};
